export default "/images/vendor/flag-icons/flags/1x1/sh-ac.svg?40ede400d2b77e9c573b5d2150dbf44d";